import { IResourceComponentsProps } from "@refinedev/core";
import { AntdInferencer } from "@refinedev/inferencer/antd";

export const UserShow: React.FC<IResourceComponentsProps> = () => {
    return <AntdInferencer />;
};
